<div class="floating-help-container" *ngIf="isVisible">
    <!-- Backdrop when menu is open -->
    <div class="menu-backdrop" *ngIf="isMenuOpen" (click)="closeMenu()"></div>

    <!-- Popup Menu -->
    <div class="help-menu" [class.open]="isMenuOpen">
        <div class="menu-header">
            <span>How can we help?</span>
        </div>

        <!-- WhatsApp Option -->
        <button class="menu-option whatsapp-option" (click)="openWhatsApp()">
            <i class="fa-brands fa-whatsapp"></i>
            <div class="option-text">
                <span class="option-title">Chat on WhatsApp</span>
                <span class="option-subtitle">Get quick support</span>
            </div>
        </button>

        <!-- Report Problem Option -->
        <button class="menu-option report-option" (click)="reportProblem()" [disabled]="isReporting">
            <i class="fas fa-bug" *ngIf="!isReporting"></i>
            <span class="spinner-border spinner-border-sm" *ngIf="isReporting"></span>
            <div class="option-text">
                <span class="option-title">Report a Problem</span>
                <span class="option-subtitle">Send diagnostic info to our team</span>
            </div>
        </button>
    </div>

    <!-- Main Floating Button (WhatsApp style) -->
    <button class="floating-help-button" (click)="toggleMenu()" [class.active]="isMenuOpen">
        <i class="fa-brands fa-whatsapp" *ngIf="!isMenuOpen"></i>
        <i class="fas fa-times" *ngIf="isMenuOpen"></i>
    </button>
</div>
